// store/slices/solutionLoadingAnimationSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TaskProgress {
  [key: string]: number;
}

interface SolutionLoadingAnimationState {
  activeTab: number;
  currentMessage: string;
  loadingDots: string;
  completedIcons: boolean[];
  cardVisible: boolean;
  arrowAnimation: boolean;
  taskProgress: TaskProgress;
}

const initialState: SolutionLoadingAnimationState = {
  activeTab: 0,
  currentMessage: '',
  loadingDots: '',
  completedIcons: [false, false, false],
  cardVisible: false,
  arrowAnimation: false,
  taskProgress: {},
};

const solutionLoadingAnimationSlice = createSlice({
  name: 'solutionLoadingAnimation',
  initialState,
  reducers: {
    setActiveTab(state, action: PayloadAction<number>) {
      state.activeTab = action.payload;
    },
    setCurrentMessage(state, action: PayloadAction<string>) {
      state.currentMessage = action.payload;
    },
    setCardsVisible(state, action: PayloadAction<boolean>) {
      state.cardVisible = action.payload;
    },
    setArrowAnimation(state, action: PayloadAction<boolean>) {
      state.arrowAnimation = action.payload;
    },
    setIconCompleted(state, action: PayloadAction<number>) {
      state.completedIcons[action.payload] = true;
    },
    completeTask(state, action: PayloadAction<{ taskName: string; value: number }>) {
      state.taskProgress[action.payload.taskName] = action.payload.value;
    },
    updateProgress(state, action: PayloadAction<{ key: string; value: number }>) {
      state.taskProgress[action.payload.key] = action.payload.value;
    },
    markTabCompleted(state, action: PayloadAction<number>) {
      state.completedIcons[action.payload] = true;
    },
    updateLoadingDots(state) {
      const maxDots = 3;
      const dotCount = (state.loadingDots.length + 1) % (maxDots + 1);
      state.loadingDots = '.'.repeat(dotCount);
    },

    resetAnimation(state) {
      state.activeTab = 0;
      state.currentMessage = '';
      state.loadingDots = '';
      state.completedIcons = [false, false, false];
      state.cardVisible = false;
      state.arrowAnimation = false;
      state.taskProgress = {};
    },
  },
});

export const {
  setActiveTab,
  setCurrentMessage,
  setCardsVisible,
  setArrowAnimation,
  setIconCompleted,
  completeTask,
  updateProgress,
  markTabCompleted,
  updateLoadingDots,
  resetAnimation,
} = solutionLoadingAnimationSlice.actions;

export default solutionLoadingAnimationSlice.reducer;
